/**
 * This component is used to display skeleton loading animations.
 *
 * @see https://ui.shadcn.com/docs/primitives/skeleton
 */
import { cn } from "../../lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted", className)}
      {...props}
    />
  )
}

export { Skeleton }
